module.exports = __webpack_public_path__ + "static/media/email-dark.7ab4bc6e.svg";